import React from "react";
interface props {
  className?: string;
}

function ChatsAboutus({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      className={className}
      viewBox="0 0 60 60"
    >
      <path
        fill="#5D5FEF"
        d="M52.5 22.5v30L43.223 45H20.625a1.875 1.875 0 01-1.875-1.875V33.75h20.625a1.875 1.875 0 001.875-1.875v-11.25h9.375A1.875 1.875 0 0152.5 22.5z"
        opacity="0.2"
      ></path>
      <path
        fill="#5D5FEF"
        d="M50.625 18.75h-7.5v-7.5a3.75 3.75 0 00-3.75-3.75h-30a3.75 3.75 0 00-3.75 3.75v30a1.875 1.875 0 003.047 1.458l8.203-6.614v7.031a3.75 3.75 0 003.75 3.75H42.56l8.768 7.083c.332.268.745.415 1.172.417a1.875 1.875 0 001.875-1.875v-30a3.75 3.75 0 00-3.75-3.75zM15.598 32.292l-6.223 5.032V11.25h30v20.625H16.777c-.43 0-.846.147-1.18.417zm35.027 16.282l-6.223-5.032a1.875 1.875 0 00-1.172-.417H20.625v-7.5h18.75a3.75 3.75 0 003.75-3.75V22.5h7.5v26.074z"
      ></path>
    </svg>
  );
}

export default ChatsAboutus;
